import { Component, HostListener, Input, SimpleChanges } from '@angular/core';
import { merge, Subject, Subscription, takeUntil } from 'rxjs';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { environment } from 'src/environments/environment';
import { UnitTypeEnum } from '../../models/unit-type-enum';
import { RetailRentalReportConstant } from './report-retail-rental.constants';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { RetailRentalMenuEnum } from './report-retail-rental-v2.enum';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportRetailRentalService } from './report-retail-rental.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'src/app/common/services/store.service';
import { DataType } from 'src/app/common/models/enums/common.enum';
import moment from 'moment';

@Component({
  selector: 'app-report-retail-rental-v2',
  templateUrl: './report-retail-rental-v2.component.html',
  styleUrls: ['./report-retail-rental-v2.component.scss'],
})
export class ReportRetailRentalComponentV2 {
  @Input() isPremium: boolean = false;
  @Input() params: any;
  RYDCHECK = environment.RYDCHECK;
  UnitTypeEnum = UnitTypeEnum;
  currentScroll: any = '';
  overViewMenu = this.isPremium? RetailRentalReportConstant.overViewMenuL3 : RetailRentalReportConstant.overViewMenuL1;
  retailUnitColumns = RetailRentalReportConstant.retailUnitColumns;
  retailUnitsizeColumns = RetailRentalReportConstant.retailUnitsizeColumns;
  retailUnitsizeExpandColumns = RetailRentalReportConstant.retailUnitsizeExpandColumns;
  unitSizeDropdown = RetailRentalReportConstant.unitSizeDropdown;
  retailRentMallWiseColumns = RetailRentalReportConstant.retailRentMallWiseColumns;

  chartView = ReportsChartEnum;
  retailRentalMenuEnum = RetailRentalMenuEnum;
  placeName = '';
  userInfo: any = 0;
  placeCode: string = '';
  CurrencyCode: string = '';
  propertyInfo: any = {};
  isFirstTime = true;
  overViewLoaderAverage:boolean = false;
  overViewLoaderOccupancy:boolean = false;
  overViewSummaryAvgRentRate: any = null;
  overViewSummaryOccupancyRate: any = null;
  overViewSubCategory: any = null;

  retailUnitdata: any = [];
  retailUnitCount: number = 0;
  retailUnitLoading: boolean = false;
  retailRentalRentrateReport: any = null;

  retailUnitsizedata: any = [];
  retailUnitsizeCount: number = 0;
  retailUnitsizeLoading: boolean = false;

  houserentalChartLoading: boolean = false;
  houserentalChart: any = [];

  resetPaginator: boolean = false;
  currentPageIndex: number = 0;

  retailRentalChartLoading = false;
  overviewOccupancy: any[] = [];
  overviewAverageRate: any[] = [];
  overViewCategory: any = null;
  selectedChartValue: any[] = [];
  retailRentalChartReport: any[] = [];
  moreText: any;
  langName: any;
  isChart = true;
  retailRentOption: string = 'retailRentOption';
  downloadLoading: any = {
    a: false,
    b: false,
    c: false
  };
  sqm_unit: string = '';
  graphLoader: boolean = false;
  globalContants: any = GlobalContants;
  retailMallWiseLoading: boolean = false;
  retailMallWisedata: any = [];
  retailMallWiseCount: number = 0;
  rentRatedropDownValue: string = '';
  showPropertyDetails: boolean = false;
  transactionPropertyDetails$ = new Subscription();
  tableName: unknown = '';
  private destroy$ = new Subject<void>();
  private retailMallWise$ = new Subject<void>();
  private retailUnit$ = new Subject<void>();
  private retailUnitSizeWise$ = new Subject<void>();
  private RetailRentalRentRate$ = new Subject<void>();
  private overViewOccupancy$ = new Subject<void>();
  private overViewAverage$ = new Subject<void>();

  constructor(
    public sharedService: SharedService,
    private reportRetailRentalService: ReportRetailRentalService,
    private alertService: AlertService,
    public reportService: ReportService,
    public translate: TranslateService,
    private storeService: StoreService
  ) {
    this.sqm_unit =
      'reports.' + GlobalContants.keySymbolContants.squareMeterUnit;
      this.sharedService.language$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lang) => {
        this.langName = lang;
        if (this.langName && !this.isFirstTime) {
          this.getReports();
          this.isChart = false;
          this.storeService.clear(this.retailRentOption);
        }
      });
  }

  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    });
  }

  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }

  ngOnInit() {

    this.overViewMenu = this.isPremium? RetailRentalReportConstant.overViewMenuL3 : RetailRentalReportConstant.overViewMenuL1;
     //Overview menu text update yearly & montly case
     if (
      this.sharedService.priceCalculation$() === this.sharedService.priceYearly
    ) {
      this.overViewMenu[1]['label'] = 'reports.annualRentUnitSizeWise';
      this.overViewMenu[2]['label'] = 'reports.annualRentMallWise';
    }
    //Update Column Monthly/Annual Rent Mall Wise Table
    if (
      this.sharedService.priceCalculation$() === this.sharedService.priceYearly
    ) {
      const columnsToUpdate = [
        {
          header: 'avg_lease_rate',
          columnName: 'reports.averageAnnualLeaseRate',
        },
        {
          header: 'min_lease_rate',
          columnName: 'reports.min_annual_lease_rate',
        },
        {
          header: 'max_lease_rate',
          columnName: 'reports.max_annual_lease_rate',
        },
      ];
      columnsToUpdate.forEach((column) => {
        const targetColumn = this.retailRentMallWiseColumns.find(
          (x) => x.header === column.header
        );
        if (targetColumn) {
          targetColumn.columnName = column.columnName;
        }
      });
      this.retailUnitColumns =
        RetailRentalReportConstant.retailUnitColumnsYearly;
    }
    this.getReports();
    this.transactionPropertyDetails();
    this.isFirstTime = false;
    this.userInfo = this.sharedService.getStoreValue(
      GlobalContants.StoreKey.userInfo
    );
    this.placeCode = this.sharedService.getStoreValue(
      GlobalContants.StoreKey.placeCode
    );
    this.CurrencyCode = this.sharedService.getStoreValue(
      GlobalContants.StoreKey.CurrencyCode
    );
    this.placeName = this.sharedService.getStoreValue(
      GlobalContants.StoreKey.PlaceName
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['params'] &&
      changes['params'].currentValue &&
      !changes['params'].firstChange
    ) {
      this.reportRetailRentalService.retailUnitPayload.pageNumber = 0;
      this.reportRetailRentalService.retailUnitSizePayload.pageNumber = 0;
      this.reportRetailRentalService.retailMallWisePayload.pageNumber = 0;

      this.retailUnitCount = 0;
      this.retailMallWiseCount = 0;
      this.retailUnitsizeCount = 0;

      this.propertyInfo = null;
      this.showPropertyDetails = false;
      this.getReports();
    }
  }
  /**
   * This function is used to get tha data of Rent-Mall Wise table.
   */
  getRetailRentMallWise() {
    this.retailMallWise$.next();
    this.retailMallWiseLoading = true;
    this.reportRetailRentalService
      .getRetailMallWiseV2(this.reportRetailRentalService.retailMallWisePayload)
      .pipe(takeUntil(merge(this.destroy$, this.retailMallWise$)))
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            if (res.data) {
              let cols = ['all_floor_range','lower_ground_range','ground_range','first_floor_range','second_floor_range','third_floor_range','higher_floor_range'];
              res.data.map((el: any) => {
                if(!this.isPremium){
                  el['is_layout'] = false;
                }
                Object.keys(el).map((e: any) => {
                  if (cols.includes(e)) {
                    el[e] = this.reportService.rangeToNumberFor(el[e]);
                  }
                });
                if(el.details && el.details?.length > 0){
                  el.details.map((detail: any) => {
                    // detail['property_name'] = `${detail['property_name']} <span class="td-sqmtext">${this.sharedService.reportDataValueType(DataType.squareMeter)}</span>`
                    Object.keys(el).map((e: any) => {
                      if (cols.includes(e)) {
                        detail[e] = this.reportService.rangeToNumberFor(detail[e]);
                      }
                    });
                  })
                }
              });
            }
            this.retailMallWisedata = this.reportService.setTableDataSource(res.data);
            if (
              this.reportRetailRentalService.retailMallWisePayload.pageNumber ==
              0
            ) {
              this.retailMallWiseCount = res.count;
            }
          } else {
            this.retailMallWisedata = [];
            this.retailMallWiseCount = 0;
          }
          this.retailMallWiseLoading = false;
        },
        error: (error: any) => {
          this.retailMallWisedata = [];
          this.retailMallWiseCount = 0;
          this.retailMallWiseLoading = false;
        },
      });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload($event:Event): void {
    this.storeService.add(this.retailRentOption, this.selectedChartValue);
  }

  selectedYear(data: any) {
    if (data.reportType === 'unit') {
      this.reportRetailRentalService.retailUnitPayload.pageNumber = 0;
      this.reportRetailRentalService.retailUnitPayload.year = data.year;
      this.retailUnitCount = 0;
      this.getRetailUnit();
    } else if (data.reportType === 'mallUnit') {
      this.reportRetailRentalService.retailMallWisePayload.pageNumber = 0;
      this.reportRetailRentalService.retailMallWisePayload.year = data.year;
      this.retailMallWiseCount = 0;
      this.getRetailRentMallWise();
    } else {
      this.reportRetailRentalService.retailUnitSizePayload.pageNumber = 0;
      this.reportRetailRentalService.retailUnitSizePayload.year = data.year;
      this.retailUnitsizeCount = 0;
      this.getRetailUnitSize();
    }
  }

  getReports() {
    this.getOverviewSummaryAverageRentRate();
    this.getOverviewSummaryOccupancyRate();
    this.getRetailUnitSize();
    this.getRetailUnit();
    this.getRetailRentMallWise();
    // this.getOverviewSubCategory();
    this.getRetailRentalRentrateReport();
  }
  /**
   * Property Details
   */
  transactionPropertyDetails() {
    this.transactionPropertyDetails$ =
      this.reportService.transactionPropertyDetails.subscribe((data) => {
        if (data) {
          this.showPropertyDetails = true;
        } else {
          this.showPropertyDetails = false;
        }
      });
  }
  /**
   * This function is used to get the overview summary of Average rent rate.
   */
  getOverviewSummaryAverageRentRate() {
    this.overViewLoaderAverage = true;
    this.overViewAverage$.next();
    this.reportRetailRentalService.getOverviewSummary('average')
    .pipe(takeUntil(merge(this.destroy$,this.overViewAverage$)))
    .subscribe({
      next: (res: any) => {
        this.overViewLoaderAverage = false;
        if (res.status === 200) {
          this.overViewSummaryAvgRentRate = res.data;
          if (!this.overViewSummaryAvgRentRate?.min_date || !this.overViewSummaryAvgRentRate?.max_date) {
            this.overViewSummaryAvgRentRate['untillDate'] = moment.utc(this.overViewSummaryAvgRentRate.as_of_date).local().format('DD MMM YYYY');
          }
          this.overviewAverageRate = this.overViewSummaryAvgRentRate.average_rate;

        } else {
          this.overViewSummaryAvgRentRate = {};
          this.overviewAverageRate = [];
        }
      },
      error: (error: any) => {
        this.overViewSummaryAvgRentRate = {};
        this.overviewAverageRate = [];
        this.overViewLoaderAverage = false;
      },
    });
  }
  getOverviewSummaryOccupancyRate() {
    this.overViewOccupancy$.next();
    this.overViewLoaderOccupancy = true;
    this.reportRetailRentalService.getOverviewSummary('occupancy')
    .pipe(takeUntil(merge(this.destroy$,this.overViewOccupancy$)))
    .subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.overViewSummaryOccupancyRate = res.data?.occupancy;
          if (!this.overViewSummaryOccupancyRate?.min_date || !this.overViewSummaryOccupancyRate?.max_date) {
            this.overViewSummaryOccupancyRate['untillDate'] = moment.utc(this.overViewSummaryOccupancyRate.as_of_date).local().format('DD MMM YYYY');
          }
            let overviewOccupancyData: any =
            this.reportService.getPercentageOverview(
              this.overViewSummaryOccupancyRate.occupancy
            );
          this.overviewOccupancy = this.barSortData(overviewOccupancyData);
        } else {
          this.overViewSummaryOccupancyRate = null;
        }
        this.overViewLoaderOccupancy = false;
      },
      error: (error: any) => {
        this.overViewSummaryOccupancyRate = null;
        this.overViewLoaderOccupancy = false;
      },
    });
  }
  getRetailRentalRentrateReport() {
    this.retailRentalChartLoading = true;
    this.RetailRentalRentRate$.next();
    this.reportRetailRentalService.getRetailRentalRentrateReportV2()
    .pipe(takeUntil(merge(this.destroy$,this.RetailRentalRentRate$)))
    .subscribe({
      next: (res: any) => {
        this.retailRentalChartLoading = false;
        if (res.status === 200) {
          this.retailRentalRentrateReport = this.sharedService.sortObjectByKeyV2(res.data);
          this.selectedChartValue = [...Object.keys(this.retailRentalRentrateReport).slice(0, 3)];
          Object.keys(this.retailRentalRentrateReport).forEach((key, index) => {
            let data = this.retailRentalRentrateReport[key];
            this.retailRentalRentrateReport[key] = data.map((obj: any) => ({
              category: String(obj.year),
              value: obj.count,
              name: key,
            }));
          });

          let retailChart = Object.keys(this.retailRentalRentrateReport)
          .filter((key) => this.selectedChartValue.includes(key))


          // Update the retail rental chart report
          this.retailRentalChartReport = retailChart.reduce((obj: any, key: any) => {
              obj[key] = this.retailRentalRentrateReport[key];
              return obj;
            }, {});
            setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));

        } else {
          this.retailRentalChartReport = [];
          this.retailRentalRentrateReport = null;
          this.selectedChartValue = [];
        }
      },
      error: (error: any) => {
        this.retailRentalChartReport = [];
        this.selectedChartValue = [];
        this.retailRentalRentrateReport = null;
        this.retailRentalChartLoading = false;
      },
    });
  }

  originalOrder = () => 0;

  getReportKeys(): string[] {
    if (this.retailRentalRentrateReport) {
      return Object.keys(this.retailRentalRentrateReport);
    }
    return [];
  }
  barSortData(data: any) {
    let overviewArray: any = Object.entries(data);
    return overviewArray.sort(
      (a: any, b: any) => b[1].category - a[1].category
    );
  }

  /**
   * This function is used to get the data of retail unit size wise table.
   */
  getRetailUnitSize() {
    this.retailUnitsizeLoading = true;
    this.retailUnitSizeWise$.next();
    this.reportRetailRentalService
      .getRetailUnitSizeV2(this.reportRetailRentalService.retailUnitSizePayload)
      .pipe(takeUntil(merge(this.destroy$,this.retailUnitSizeWise$)))
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            if (res.data) {
              let cols = [
                'all_floor_range',
                'lower_ground_range',
                'ground_range',
                'first_floor_range',
                'second_floor_range',
                'third_floor_range',
                'higher_floor_range'
              ];

              res.data.map((el: any) => {
                Object.keys(el).map((e: any) => {
                  if (cols.includes(e)) {
                    el[e] = this.reportService.rangeToNumberFor(el[e]);
                  }
                  if (el.details && el.details.length > 0) {
                    el.details.map((detail: any) => {
                      Object.keys(detail).map((key: any) => {
                        if (cols.includes(key)) {
                          detail[key] = this.reportService.rangeToNumberFor(
                            detail[key]
                          );
                        }
                      });
                    });
                  }
                });
              });
            }

            this.retailUnitsizedata = this.reportService.setTableDataSource(res.data);
            if (
              this.reportRetailRentalService.retailUnitSizePayload.pageNumber ==
              0
            ) {
              this.retailUnitsizeCount = 0;
            }
          } else {
            this.retailUnitsizedata = [];
            this.retailUnitsizeCount = 0;
          }
          this.retailUnitsizeLoading = false;
        },
        error: (error: any) => {
          this.retailUnitdata = [];
          this.retailUnitsizeCount = 0;
          this.retailUnitsizeLoading = false;
        },
      });
  }
  /**
   * This function is used to get the data of units-in selected properties table
   */
  getRetailUnit() {
    this.retailUnitLoading = true;
    this.retailUnit$.next();
    this.reportRetailRentalService
      .getRetailUnitV2(this.reportRetailRentalService.retailUnitPayload)
      .pipe(takeUntil(merge(this.destroy$,this.retailUnit$)))
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.retailUnitdata =  this.reportService.setTableDataSource(res.data);
            if (
              this.reportRetailRentalService.retailUnitPayload.pageNumber == 0
            ) {
              this.retailUnitCount = res.count;
            }
          } else {
            this.retailUnitdata = [];
            this.retailUnitCount = 0;
          }
          this.retailUnitLoading = false;
        },
        error: (error: any) => {
          this.retailUnitdata = [];
          this.retailUnitCount = 0;
          this.retailUnitLoading = false;
        },
      });
  }

  downloadExcel(event: any, type: string, key: any) {
    this.downloadRentalReport(type, key);
  }

  downloadRentalReport(type: string, key: any) {
    this.downloadLoading[key] = true;
    this.reportService.downloadReport(type, this.userInfo?.user_id).subscribe({
      next: (res: any) => {
        this.downloadLoading[key] = false;
        if (res.status === 200) {
          const downloadUrl = `${this.sharedService.downloadExcelPath()}?file_name=${
            res.data
          }&city_code=${this.placeCode.toLowerCase()}&module_name=retail_rental`;
          this.sharedService.downloadExcelUrl(downloadUrl);
          this.alertService.success(
            this.translate.instant('reports.downloadRequestSubmitted')
          );
        } else {
          this.alertService.warn(res.message);
        }
      },
      error: (error: any) => {
        this.downloadLoading[key] = false;
      },
    });
  }

  onPageEvent(e: any, report: any) {
    if (e.previousPageIndex !== e.pageIndex) {
      if (report === this.retailRentalMenuEnum.retailUnit) {
        this.reportRetailRentalService.retailUnitPayload.pageNumber =
          e.pageSize * e.pageIndex;
        this.getRetailUnit();
      } else if (report === this.retailRentalMenuEnum.retailRentMallWise) {
        this.reportRetailRentalService.retailMallWisePayload.pageNumber =
          e.pageSize * e.pageIndex;
        this.getRetailRentMallWise();
      } else {
        this.reportRetailRentalService.retailUnitSizePayload.pageNumber =
          e.pageSize * e.pageIndex;
        this.getRetailUnitSize();
      }
    }
  }

  sortData(event: any, report: any) {
    let sort = {
      column: event.active,
      order: event.direction,
    };
    if (report === this.retailRentalMenuEnum.retailUnit) {
      this.reportRetailRentalService.retailUnitPayload.pageNumber = 0;
      this.reportRetailRentalService.retailUnitPayload.sort_order =
        JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getRetailUnit();
    } else if (report === this.retailRentalMenuEnum.retailRentMallWise) {
      this.reportRetailRentalService.retailMallWisePayload.pageNumber = 0;
      this.reportRetailRentalService.retailMallWisePayload.sort_order =
        JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getRetailRentMallWise();
    } else {
      this.reportRetailRentalService.retailUnitSizePayload.pageNumber = 0;
      this.reportRetailRentalService.retailUnitSizePayload.sort_order =
        JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getRetailUnitSize();
    }
  }

  dropDownChange(value: any, type:string = "") {
    this.rentRatedropDownValue = value;
    if (value === 'Range') {
      if(type === 'unitSize') {
        this.retailUnitsizeColumns =
        RetailRentalReportConstant.retailUnitsizeColumns;
        this.retailUnitsizeExpandColumns =
        RetailRentalReportConstant.retailUnitsizeExpandColumns;
      }else if(type === 'mallWise') {
        this.retailRentMallWiseColumns = RetailRentalReportConstant.retailRentMallWiseColumns
      }
    } else {
      if(type === 'unitSize') {
        this.retailUnitsizeColumns =
        RetailRentalReportConstant.retailUnitsizeAverageColumns;
        this.retailUnitsizeExpandColumns =
        RetailRentalReportConstant.retailUnitsizeExpandAverageColumns;
      }else if(type === 'mallWise') {
        this.retailRentMallWiseColumns = RetailRentalReportConstant.retailRentMallWiseAverageColumns
      }
    }
  }

  lastClickedTable(event: Event, table: any) {
    this.tableName = table;
  }
  selectChart(e: any, value: any) {
    let index = this.selectedChartValue.indexOf(value);
    if (!e.checked) {
      if (this.selectedChartValue.length === 1) {
        this.alertService.warn(this.translate.instant('atLeastOneMust'));
        e.source.checked = true;
      } else {
        this.selectedChartValue.splice(index, 1);
      }
    } else {
      if (this.selectedChartValue.length > 2) {
        this.alertService.warn(
          this.translate.instant('youCannotSelectMoreThan')
        );
        e.source.checked = false;
        return;
      } else {
        this.selectedChartValue.push(value);
      }
    }

    this.retailRentalChartReport = Object.keys(this.retailRentalRentrateReport)
      .filter((key) => this.selectedChartValue.includes(key))
      .reduce((obj: any, key: any) => {
        obj[key] = this.retailRentalRentrateReport[key];
        return obj;
      }, {});
    this.retailRentalChartReport = this.sharedService.sortObjectByKeyV2(
      this.retailRentalChartReport
    );

    this.retailRentalChartLoading = false;
    setTimeout(() => this.moreText = this.reportService.optionsCountDropdown(this.selectedChartValue));
  }

  // getOpacity(index:number, value: any, type: string): string{
  //   // Adjust the factor and starting value as per your requirement
  //   return this.reportRetailRentalService.changeOpacity(index, value, type);
  // }
  // getNumber(nbr: any){
  //   return +nbr;
  // }
  ngOnDestroy() {
    this.storeService.clear(this.retailRentOption);
    this.transactionPropertyDetails$.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.retailMallWise$.complete()
    this.retailUnit$.complete()
    this.retailUnitSizeWise$.complete()
    this.RetailRentalRentRate$.complete()
    this.overViewOccupancy$.complete()
    this.overViewAverage$.complete()
  }
}
